import { render } from "./ClinicForm.vue?vue&type=template&id=30273cda&scoped=true&ts=true"
import script from "./ClinicForm.vue?vue&type=script&lang=ts"
export * from "./ClinicForm.vue?vue&type=script&lang=ts"

import "./ClinicForm.vue?vue&type=style&index=0&id=30273cda&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30273cda"]])

export default __exports__